import get from 'lodash.get';

/**
 * @param {Object[]} collection
 * @param {String} key
 * @param {any} value
 *
 * @return {Object}
 */
export function where(collection, key, value) {
  if (!collection) {
    return collection;
  }

  const values = Object.values(collection);
  if (!values.length) {
    return [];
  }

  const out = values.filter((item) => get(item, key) === value);
  return Array.from(out);
}

/**
 * @param {Object[]} collection
 * @param {String[]} groupId
 * @return {Object[]}
 */
export function whereGroup(collection, groupId) {
  return where(collection, 'group_uuid', groupId);
}

/**
 * @param {Object[]} collection
 * @param {String[]} ownerId
 * @return {Object[]}
 */
export function whereOwner(collection, ownerId) {
  return where(collection, 'owner_uuid', ownerId);
}

/**
 * @param {Object[]} collection
 * @param {String[]} parentId
 * @return {Object[]}
 */
export function whereParent(collection, parentId) {
  return where(collection, 'parent_uuid', parentId);
}
